/*
 * Copyright (c) 2020  Apricot Courses, LLC. All Rights Reserved.
 */

import {
  title,
  mrAuto,
  mlAuto,
  cardTitle,
  container,
  warningColor,
} from "assets/jss/material-kit-pro-react.jsx";
import { pageContent } from "assets/jss/views/apricot.jsx";
import javascriptStyles from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.jsx";
import modalStyle from "assets/jss/material-kit-pro-react/modalStyle.jsx";
import tooltipsStyle from "assets/jss/material-kit-pro-react/tooltipsStyle.jsx";
import switchStyle from "assets/jss/material-kit-pro-react/customCheckboxRadioSwitchStyle.jsx";
import { niceScrollbar } from "assets/jss/views/classroomPage/classroomStyle";
import { brand, showFor1024Up, showFor1023Down } from "../apricot.jsx";

export const inputErrorStyle = {
  fontSize: "0.8rem",
  fontWeight: 500,
  color: warningColor[0],
  lineHeight: "1.2rem",
  display: "block",
};

const icon = {
  width: "2rem",
  height: "2rem",
  margin: "0, 0, 0, 0,5rem",
  display: "inline-block",
};

const link = {
  cursor: "pointer",
  fontWeight: 700,
};

const styles = (theme) => {
  const title = { ...title, fontFamily: theme.typography.fontFamily };
  const {
    modal,
    modalRoot,
    modalLogin,
    modalLoginCard,
    modalHeader,
    modalBody,
    modalFooter,
    modalCloseButton,
    alert,
    alertBody,
    alert_secondary,
  } = modalStyle(theme);

  const {
    justifyContentCenter,
    cardLoginBody,
    socialLineButton,
  } = javascriptStyles(theme);

  return {
    "@global": niceScrollbar,

    title: {
      ...title,
      color: "#FFFFFF !important",
      zIndex: "5",
    },

    pageContent: {
      ...pageContent,
      "& p": {
        fontSize: "1.2rem",
        fontWeight: 300,
        color: "#303030",
      },
    },
    mrAuto,
    container,

    justifyContentCenter,
    cardLoginBody,
    socialLineButton,

    modal,
    modalRoot,
    modalLogin: { ...modalLogin, minWidth: "300px" },
    modalLoginCard,
    modalHeader,
    modalBody,
    modalFooter,
    modalCloseButton,
    alert,
    alertNormal: alert_secondary,
    alertBody,

    brand,
    showFor1024Up,
    showFor1023Down,

    section: {
      padding: "30px 0",
    },

    signinContainer: {
      overflow: "auto",
      "@media (min-width: 960px)": {
        height: "100vh",
      },
    },

    signinPanel: {
      "@media (max-width: 830px)": {
        marginLeft: "5px",
        marginRight: "5px",
      },
      margin: "-98vh 2rem 1rem",
    },

    cardSignup: {
      borderRadius: "6px",
      boxShadow:
        "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2);",
      margin: "60px auto auto",
      padding: "40px 0px",
      backgroundColor: "#FFFDF5",
    },

    cardTitle: {
      ...cardTitle,
      textAlign: "center",
    },

    ...tooltipsStyle,
    ...switchStyle,
    infoArea: {
      maxWidth: "360px",
      margin: "0 auto",
      padding: "12px 0 0 0",
      fontFamily: "Open Sans",
    },

    inputError: inputErrorStyle,

    legalNote: {
      cursor: "pointer",
      color: theme.palette.secondary.dark,
      fontSize: "1rem",
      fontWeight: "600",
      textTransform: "uppercase",
      textDecoration: "underline",
    },

    loginLink: {
      cursor: "pointer",
      color: theme.palette.secondary.dark,
      fontWeight: 700,
    },

    signupLink: {
      ...link,
      color: theme.palette.primary.dark,
    },

    resetPW: {
      ...link,
      color: theme.palette.secondary.dark,
      textTransform: "uppercase",
    },

    profileGrid: {
      maxWidth: "22.5rem",
      margin: "0 auto -20px auto",
    },

    reminder: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      width: "100%",
      marginTop: "3rem",
    },
  };
};

export default styles;
